import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
	Box,
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControlLabel,

	Typography,
	Stack,
} from "@mui/material";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WarningIcon from "@mui/icons-material/Warning";

import NumberField from "../Common/NumberField";

export default function BidsProspectDialog(props) {
	console.log("BidsDialogProspect", props);

	const [disabled, setDisabled] = useState(true);
	const handleClose = () => {
		props.onClose();
	};

	const [state, setState] = useState({

		step: "step1",
		price: 0,
		amount: 0,
		loan: 0,
		rate: 0,
		amortization: 0,
		no_suspensive: true
	});
	const handleChange = (event) => {
		console.log("event", event);
		if (event.target.name === "amount") {
			var amt = event.target.value;
			if (amt === "") {
				return;
			}
			const amnt = Math.min(parseInt(amt, 10), state.price);
			//const amnt = Math.min(parseInt(event.target.value, 10), params.mnt);

			const ln = state.price - amnt;

			setState({
				...state,
				amount: amnt,
				loan: ln,
			});
		} else {
			if (parseInt(event.target.value, 10) > props.state.params.seller_price_num) {
				console.log("set to max");
				setState({ ...state, price: props.state.params.seller_price_num })

			} else {
				setState({ ...state, [event.target.name]: event.target.value });
			}

		}
	};

	useEffect(() => {
		//console.log(mode, state, parseInt(state.price, 10), state.price, parseInt(state.price, 10));
		console.log(parseInt(state.price, 10), props.state.params.seller_price_num)

		if (parseInt(state.price, 10) > 0) {
			if (state.no_suspensive === true) {
				setDisabled(false);
			} else {
				if ((parseInt(state.amount, 10) > 0)) { setDisabled(false); }
				else {
					setDisabled(true);
				}
			}

		} else {
			setDisabled(true);
		}
		if (state.no_suspensive === true && (state.amount > 0)) {
			setState({ ...state, amount: 0, loan: 0 })
		}
	}, [state]);
	const manageSubmit = () => {
		console.log("manageSubmit", state);
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				...state,
				uid: props.state.params.uid,
			}),
		};
		var url = "/api/newbid_pr";


		fetch(url, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	const handleChangeCheckbox = (event) => {
		console.log(event.target.name, event.target.checked)
		//setState({ ...state, [event.target.name]: event.target.checked });
		setState({ ...state, no_suspensive: !state.no_suspensive });
	};
	//console.log(params);
	Date.prototype.addDays = function (days) {
		let date = new Date(this.valueOf());
		date.setDate(date.getDate() + days);
		//console.log(date);
		return date;
	};
	let date = new Date();
	var tgdd = 2;

	const d_plus_1d = date.addDays(tgdd);
	const options = {
		weekday: "long",
		year: "numeric",
		month: "long",
		day: "numeric",
	};
	const d_plus_1d_txt = d_plus_1d.toLocaleTimeString("fr-fr", options);

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="sm" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5">Faire une proposition d'achat</Typography>
			</DialogTitle>
			<DialogContent dividers>
				{state.step === "step1" && <Stack spacing={1}>
					{props.state.params.prev && <Box display="flex" justifyContent="flex-start" alignItems="center">
						<Box>
							<WarningIcon color="primary" />
						</Box>
						<Box>
							<Typography style="margin-left: 8px; ">Une nouvelle proposition remplace la précédente</Typography>
						</Box>
					</Box>}
					<Box display="flex" justifyContent="flex-start" alignItems="center">
						<Box>
							<WarningIcon color="primary" />
						</Box>
						<Box>
							<Typography style="margin-left: 8px; ">Vous ne pouvez pas légalement enchérir plus que le prix de vente</Typography>
						</Box>
					</Box>
					<Box display="flex" justifyContent="flex-start" alignItems="center">
						<Box>
							<Typography variant="h5">Mise à prix</Typography>
						</Box>
						<Box p={1}>
							<Typography variant="h5">{props.state.params.seller_price} €</Typography>

						</Box>
					</Box>
					<Box display="flex" justifyContent="flex-start" alignItems="center">
						<Box>
							<AccessTimeIcon />
						</Box>
						<Box>
							<Typography variant="body1" style="margin-left: 8px; height: 24px;">
								L'offre sera valable jusqu'au {d_plus_1d_txt.substring(0, d_plus_1d_txt.length - 3)}
							</Typography>
						</Box>
					</Box>

					<Box display="flex" justifyContent="flex-start" alignItems="center">
						<Box>
							<Typography variant="h5">Montant de l'offre</Typography>
						</Box>
						<Box p={1}>
							<NumberField value={state.price > 0 ? state.price : ""} onChange={handleChange} id="price" />

						</Box>
					</Box>

					{/* Vous devez indiquer les conditions de financement  */}
					<Typography variant="body1">
						Vos conditions de financement:
					</Typography>

					<Box display="flex" justifyContent="flex-start" alignItems="space-between" flexDirection="column">
						<Box>
							<FormControlLabel
								control={
									<Checkbox
										checked={state.no_suspensive}
										onChange={handleChangeCheckbox}
										name="no_suspensive"
										color="primary"
									/>
								}
								label="Sans condition suspensive d'obtention d'un prêt"
							/>
						</Box>
						<Box>
							<FormControlLabel
								control={
									<Checkbox
										checked={!state.no_suspensive}
										onChange={handleChangeCheckbox}
										name="no_suspensive"
										color="primary"
									/>
								}
								label="Avec condition suspensive d'obtention d'un prêt"
							/>
						</Box>
						{!state.no_suspensive && <Box>
							<Box display="flex" justifyContent="flex-start" alignItems="center">
								<Box>
									<Typography variant="h5">Montant apport personnel</Typography>
								</Box>
								<Box p={1}>
									<NumberField
										value={state.amount > 0 ? state.amount : ""}
										onChange={handleChange}
										disabled={state.price == 0}
										id="amount"
										placeholder="Montant en euros" />
								</Box>
							</Box>
						</Box>}

						{!state.no_suspensive && state.loan > 0 && (
							<Box>
								<Box display="flex" justifyContent="flex-start" alignItems="center">
									<Box>
										<Typography variant="h5">Montant financé&nbsp;</Typography>
									</Box>
									<Box p={1}>
										<Typography variant="body1">{state.loan.toString().match(/(\d+?)(?=(\d{3})+(?!\d)|$)/g).join(' ')} €</Typography>
									</Box>
								</Box>
							</Box>
						)}



					</Box>
				</Stack>}
				{state.step === "step2" && <Stack spacing={1}>
					<Typography variant="h5">
						CONFIRMATION ?
					</Typography>
					<Typography variant="h5">
						Voulez-vous vraiment faire cette offre ?
					</Typography>
					<Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
						<Box>
							<Typography variant="body1">
								Montant
							</Typography>
						</Box>
						<Box>
							<Typography variant="body1">
								{state.price.toString().match(/(\d+?)(?=(\d{3})+(?!\d)|$)/g).join(' ')} €
							</Typography>
						</Box>
					</Box>

				</Stack>}
			</DialogContent>
			<DialogActions>
				<Box display={"flex"} justifyContent="space-between" alignItems={"center"} style="width: 100%;">
					<Box>
						{state.step === "step2" && <Button onClick={() => setState({ ...state, step: "step1" })} variant="contained">
							Annuler
						</Button>}
						{state.step === "step1" && <Button onClick={handleClose} variant="contained">
							Annuler
						</Button>}
					</Box>
					<Box >
						{state.step === "step1" && <Button
							onClick={() => setState({ ...state, step: "step2" })}
							variant="contained"
							disabled={disabled}
						>
							Proposer
						</Button>}
						{state.step === "step2" && <Button onClick={manageSubmit} variant="contained">
							Proposer
						</Button>}
					</Box>
				</Box>
			</DialogActions>
		</Dialog >
	);
}
